import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import './navmenu.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function SathyaSaiMenu() {
  return (
    <Navbar expand="lg" className="navbar">
      <Container>
        <Navbar.Brand href="/" className="text-center mx-auto d-flex flex-column align-items-center">
        <img
            src="/images/sc-logo.png" // Replace with the actual path to your logo
            alt="Sri Sathya Sai Center Milwaukee"
            className="logo img-fluid mb-2" // Add any additional classes you need
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/sse"><strong>SSE</strong></Nav.Link>
            <Nav.Link href="/study-circle"><strong>Study Circle</strong></Nav.Link>
            <Nav.Link href="/calendar"><strong>Events and Calendar</strong></Nav.Link>
            <Nav.Link href="/service"><strong>Service</strong></Nav.Link>
            <NavDropdown title={<strong>Gallery</strong>} id="gallery-dropdown">
              <NavDropdown.Item href="/gallery">All Galleries</NavDropdown.Item>
              <NavDropdown.Item href="/sai100gallery">Sai 100 Gallery</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="https://sairhythms.sathyasai.org/" target="_blank"><strong>Prayer and Bhajan</strong></Nav.Link>
            <Nav.Link href="/sathya100birthday"><strong>Sathya Sai Birthday</strong></Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default SathyaSaiMenu;